"use strict";
//
// Copyright © 2024 Hardcore Engineering Inc.
// Copyright © 2026 Intabia Fusion.
//
// Licensed under the Eclipse Public License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License. You may
// obtain a copy of the License at https://www.eclipse.org/legal/epl-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
//
// See the License for the specific language governing permissions and
// limitations under the License.
//
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.genRanks = genRanks;
exports.toRank = toRank;
exports.makeRank = makeRank;
const lexoRankBucket_1 = __importDefault(require("lexorank/lib/lexoRank/lexoRankBucket"));
const lexorank_1 = require("lexorank");
/** @public */
function genRanks(count) {
    const sys = new lexorank_1.LexoNumeralSystem36();
    const base = 36;
    const max = base ** 6;
    const gap = lexorank_1.LexoDecimal.parse(Math.trunc(max / (count + 2)).toString(base), sys);
    let cur = lexorank_1.LexoDecimal.parse('0', sys);
    const res = [];
    for (let i = 0; i < count; i++) {
        cur = cur.add(gap);
        res.push(new lexorank_1.LexoRank(lexoRankBucket_1.default.BUCKET_0, cur).toString());
    }
    return res;
}
/**
 * Normalize a legacy rank or id string into a canonical LexoRank.
 * A non-canonical fallback (plain '0|'+id) sorts inconsistently against
 * makeRank output, which breaks drag reorder - canonicalize so both agree.
 * @public
 */
function toRank(str) {
    if (str === undefined)
        return;
    const raw = str.startsWith('0|') ? str : '0|' + str.replaceAll(/[-:_]/g, '').toLowerCase();
    try {
        return lexorank_1.LexoRank.parse(raw).toString();
    }
    catch {
        return raw;
    }
}
/** @public */
function makeRank(prev, next) {
    try {
        if (prev?.trim() === '') {
            prev = undefined;
        }
        if (next?.trim() === '') {
            next = undefined;
        }
        if (prev !== undefined && next !== undefined) {
            const prevLexoRank = lexorank_1.LexoRank.parse(prev);
            const nextLexoRank = lexorank_1.LexoRank.parse(next);
            return prevLexoRank.equals(nextLexoRank)
                ? prevLexoRank.genNext().toString()
                : prevLexoRank.between(nextLexoRank).toString();
        }
        else if (prev !== undefined) {
            const prevLexoRank = lexorank_1.LexoRank.parse(prev);
            return prevLexoRank.genNext().toString();
        }
        else if (next !== undefined) {
            const nextLexoRank = lexorank_1.LexoRank.parse(next);
            return nextLexoRank.genPrev().toString();
        }
        else {
            return lexorank_1.LexoRank.middle().toString();
        }
    }
    catch (err) {
        throw new Error(`Failed to make rank: ${prev} ${next} ${err.message}`);
    }
}
//# sourceMappingURL=utils.js.map